import { useState } from 'react';
import { nanoid } from 'nanoid/non-secure';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';

var useId = function useId(staticId) {
  var _useState = useState(""),
      uuid = _useState[0],
      setUuid = _useState[1];

  useEnhancedEffect(function () {
    setUuid(nanoid());
  }, []);
  return staticId || uuid;
};

export { useId };